import {
    MotifAvatar,
    MotifHeader,
    MotifHeaderLogo,
    MotifIcon,
    MotifMenu,
    MotifButton,
    MotifMenuItem,
    MotifMenuItemGroup,
    MotifDropdownPortal,
    MotifDropdownItem,
    MotifVerticalNavigationHeaderButton as MotifVerticalNavHeaderButton,
} from '@ey-xd/motif-react';
import EYLogo from '../assets/media/images/ey-logo.png'

const Header = () => {
    return (
        <div className='headerWrapper'>
            <MotifHeader
                appHeaderName="Cyber AI"
                logo={
                    <MotifHeaderLogo>
                      <div>
                        <img src={EYLogo} alt='EY Logo - Home' width={28} className="eyLogo"/>
                      </div>
                    </MotifHeaderLogo>
                }
            ></MotifHeader>
        </div>
    )
}

export default Header;